import { CheckIcon } from 'modules/icons/Check';

import * as S from './Plataform.style';
import * as T from './Plataform.types';

export const Plataform: React.FC<T.PlataformCollection> = ({ image, list, text, title }) => {
  return (
    <S.PlataformaAberta className="section">
      <S.Container>
        <div className="text">
          <h3>{title}</h3>
          <p>{text}</p>

          {list.map((item) => {
            let strong = item.split(':');
            const p = strong.length > 1 ? strong[1] : '';
            strong = strong.length > 1 ? `${strong[0]}:` : item;
            return (
              <div key={strong} className="info">
                <CheckIcon />
                <p className="small">
                  <strong>{strong}</strong>
                  {p}
                </p>
              </div>
            );
          })}
        </div>
        <img src={image.url} alt={title} width={540} height={399} />
      </S.Container>
    </S.PlataformaAberta>
  );
};
